<template>
  <customModal
    :containermd="true"
    :footerShow="false"
    @closeModal="closeValidation()"
  >
    <!-- Modal Title -->
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.validation rule") }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-content">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="mb-0">
              {{ $t("navigations.validation rule list") || "Test Range List" }}
            </h4>

            <div class="position-relative">
              <img
                class="cursor-pointer"
                src="../../assets/img/create.png"
                alt="Create study"
                style="width: 20px; height: 20px"
                @click.prevent="showAddRangeModal()"
              />
              <div class="tool-tip">
                {{ $t("navigations.add validation rule") }}
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>Rule Code</th>
                  <th>Severity</th>
                  <th>Compare To</th>
                  <th>Operator</th>
                  <th>Threshold Value</th>

                  <th class="text-center">{{ $t("navigations.edit") }}</th>
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="result in labList" :key="result.id">
                  <td>{{ result.ruleCode }}</td>
                  <td>{{ result.severity }}</td>
                  <td>{{ result.compareTo }}</td>
                  <td>{{ result.operator }}</td>
                  <td>{{ result.thresholdValue }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      @click.prevent="editlabtest(result.id)"
                    ></i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-trash edit-delete"
                      @click.prevent="deleteLabs(result.id)"
                    ></i>
                  </td>
                </tr>
                <tr v-if="labList.length === 0 && !showLoading">
                  <td colspan="8" class="text-center">
                    No validation rules found for the selected criteria.
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              class="col-md-12 d-flex justify-content-md-end px-0"
              v-if="labList.length != 0"
            >
              <VPagination
                v-model="currentPage"
                :pages="totalItems"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="getLabMaster"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <customModal
    :containermd="true"
    :footerShow="false"
    v-if="showAddValidationRuleModal"
    @closeModal="closeValidationRule"
  >
    <template #title>
      <h4 class="my-0">
        {{
          isEditing
            ? $t("navigations.update validation rule")
            : $t("navigations.create validation rule")
        }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body scrollable">
         
          <div class="form-group row">
            <div class="col-md-3">
              <label for="ruleCode">
                {{ $t("navigations.rule code") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <input
                v-model="ruleCodeForm"
                id="ruleCode"
                type="text"
                class="form-control"
                placeholder="Enter rule code"
              />
              <span class="errormsg" v-if="errors.ruleCode">{{
                errorMessages.ruleCode
              }}</span>
            </div>

            <div class="col-md-3">
              <label for="ruleName">
                {{ $t("navigations.rule name") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <input
                v-model="ruleNameForm"
                id="ruleName"
                type="text"
                class="form-control"
                placeholder="Enter rule name."
              />
              <span class="errormsg" v-if="errors.ruleName">{{
                errorMessages.ruleName
              }}</span>
            </div>
            <div class="col-md-3">
              <label for="alertType" class="form-label">
                {{ $t("navigations.alert type") }}
                <span class="validation-block">
                  <sup><i class="fa fa-asterisk required"></i></sup>
                </span>
              </label>
              <select id="alertType" class="form-select" v-model="alertType">
                <option value="">
                  {{ $t("navigations.select alert type") }}
                </option>
                <option
                  v-for="option in alertCategories"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
              <span v-if="errors.alertType" class="errormsg ml-0">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>

            <div class="col-md-3">
              <label for="severity">
                {{ $t("navigations.severity") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <select v-model="severity" id="severity" class="form-control">
                <option value="">
                  {{ $t("navigations.select severity") }}
                </option>
                <option value="LOW">{{ $t("navigations.low") }}</option>
                <option value="MEDIUM">{{ $t("navigations.medium") }}</option>
                <option value="HIGH">{{ $t("navigations.high") }}</option>
                <option value="CRITICAL">
                  {{ $t("navigations.critical") }}
                </option>
              </select>
              <span class="errormsg" v-if="errors.severity">{{
                errorMessages.severity
              }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="description">{{ $t("navigations.description") }}</label>
            <textarea
              v-model="description"
              id="description"
              class="form-control"
              placeholder="Describe this rule"
            ></textarea>
          </div>

          <hr />
          <div class="form-group row">
            <div class="col-md-4">
              <label for="compareTo">
                {{ $t("navigations.compare to") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <select
                v-model="compareTo"
                id="compareTo"
                class="form-control"
                @change="handleCompareToChange"
              >
                <option value="">
                  {{ $t("navigations.select compareto") }}
                </option>
                <option value="Min">Min</option>
                <option value="Max">Max</option>
                <option value="Min-Max">Min-Max</option>
                <option value="Custom">Custom</option>
              </select>
              <span class="errormsg" v-if="errors.compareTo">{{
                errorMessages.compareTo
              }}</span>
            </div>
            <div class="col-md-4">
              <label for="operator">
                {{ $t("navigations.operator") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <select v-model="operator" id="operator" class="form-control">
                <option value="">
                  {{ $t("navigations.select operator") }}
                </option>
                <option value="EQUAL TO" :disabled="compareTo === 'Min-Max'">
                  Equal To
                </option>
                <option
                  value="NOT EQUAL TO"
                  :disabled="compareTo === 'Min-Max'"
                >
                  Not Equal To
                </option>
                <option
                  value="GREATER THAN"
                  :disabled="compareTo === 'Min-Max'"
                >
                  Greater Than
                </option>
                <option value="LESS THAN" :disabled="compareTo === 'Min-Max'">
                  Less Than
                </option>
                <option
                  value="GREATER THAN OR EQUAL TO"
                  :disabled="compareTo === 'Min-Max'"
                >
                  Greater Than or Equal To
                </option>
                <option
                  value="LESS THAN EQUAL"
                  :disabled="compareTo === 'Min-Max'"
                >
                  Less Than or Equal To
                </option>
                <option value="BETWEEN" :disabled="compareTo !== 'Min-Max'">
                  Between
                </option>
              </select>
              <span class="errormsg" v-if="errors.operator">{{
                errorMessages.operator
              }}</span>
            </div>

            <div class="col-md-4">
              <label for="thresholdValue">{{
                $t("navigations.threshold value")
              }}</label>
              <input
                v-model="thresholdValue"
                id="thresholdValue"
                type="text"
                class="form-control"
                placeholder="Enter threshold"
                :disabled="
                  compareTo === 'Min' ||
                  compareTo === 'Max' ||
                  compareTo === 'Min-Max'
                "
              />
              <span class="errormsg" v-if="errors.thresholdValue">{{
                errorMessages.thresholdValue
              }}</span>
            </div>
          </div>

          <hr />
          <div class="form-group row">
            <div class="col-md-4">
              <label for="visit">{{ $t("navigations.visit") }}</label>
              <input
                v-model="visit"
                id="visit"
                type="text"
                class="form-control"
                placeholder="Enter visit name"
              />
            </div>

            <div class="col-md-4">
              <label for="gender">{{
                $t("navigations.subject classification")
              }}</label>
              <select
                v-model="localGender"
                id="gender"
                class="form-control"
                disabled
              >
                <option value="">
                  {{ $t("navigations.select subject classification") }}
                </option>
                <option value="All">{{ $t("navigations.all") }}</option>
                <option value="Male">{{ $t("navigations.male") }}</option>
                <option value="Female">{{ $t("navigations.female") }}</option>
                <option value="Pregnant">
                  {{ $t("navigations.pregnant") }}
                </option>
              </select>
            </div>

            <div class="col-md-2">
              <label>{{ $t("navigations.min age") }}</label>
              <input
                v-model.number="localAgeMin"
                type="number"
                class="form-control"
                placeholder="0"
                disabled
              />
            </div>

            <div class="col-md-2">
              <label>{{ $t("navigations.max age") }}</label>
              <input
                v-model.number="localAgeMax"
                type="number"
                class="form-control"
                placeholder="0"
                disabled
              />
              <span class="errormsg" v-if="errors.ageRange">{{
                errorMessages.ageRange
              }}</span>
            </div>
          </div>

          <hr />
          <div class="form-group">
            <label for="actionMessage">
              {{ $t("navigations.alert message") }}
              <sup><i class="fa fa-asterisk imp"></i></sup>
            </label>
            <textarea
              v-model="actionMessage"
              id="actionMessage"
              class="form-control"
              placeholder="Enter message to display"
            ></textarea>
            <span class="errormsg" v-if="errors.actionMessage">{{
              errorMessages.actionMessage
            }}</span>
          </div>
          <div class="form-group">
            <label for="notificationMethod">
              {{ $t("navigations.notification method") }}
              <sup><i class="fa fa-asterisk imp"></i></sup>
            </label>
            <Multiselect
              id="notificationMethod"
              v-model="multiNotificationSelect"
              mode="multiple"
              placeholder="Select notification method"
              :options="[
                { label: 'Email Notification', value: 'Email Notification' },
                { label: 'Query Notification', value: 'Query Notification' },              
                {
                  label: 'Display Message: Information',
                  value: 'Information',
                },
              ]"
              :hideSelected="false"
              :closeOnSelect="false"
              :searchable="true"
              class="multiselect-theme"
              @change="onNotificationMethodChange"
            />
            <span v-if="errors.notificationMethod" class="errormsg ml-0">
              {{ $t("navigations.please choose a value") }}
            </span>
          </div>

          <div
            class="form-group row"
            v-if="multiNotificationSelect.includes('Email Notification') || multiNotificationSelect.includes('Query Notification')"
          >
            <div class="col-md-6">
              <label for="roleList">
                {{ $t("navigations.role") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <Multiselect
                id="roleList"
                @close="onSelectClosed()"
                @clear="onClear()"
                @select="onRoleSelect"
                @deselect="onRoleDeselect"
                v-model="multiRoleSelectList"
                mode="multiple"
                valueProp="roleID"
                placeholder="Select roles"
                label="roleName"
                :options="roleList"
                :hideSelected="false"
                :closeOnSelect="false"
                :searchable="true"
                trackBy="roleName"
                class="multiselect-theme"
              >
                <template v-slot:option="{ option }">
                  {{ option.roleName }}
                </template>
              </Multiselect>
              <span v-if="errors.roles" class="errormsg ml-0">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>

            <div class="col-md-6">
              <label for="recipients">
                {{ $t("navigations.recipients") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <Multiselect
                id="recipients"
                v-model="emailRecipients"
                mode="multiple"
                placeholder="Select recipients"
                :options="userList"
                valueProp="email"
                label="email"
                track-by="email"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-theme"
              >
                <template v-slot:option="{ option }">
                  {{ option.email }}
                </template>
              </Multiselect>
              <span v-if="errors.emailRecipients" class="errormsg ml-0">
                {{ $t("navigations.please choose a value") }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-2 d-flex align-items-center ml-2">
            <input
              type="checkbox"
              id="isAutoGeneratedQueryView"
              v-model="isAutoGeneratedQuery"
              class="form-check-input mr-2"
            />
            <label for="isAutoGeneratedQueryView" class="form-label mb-0">
              {{ $t("navigations.is auto generate query") }}
            </label>
          </div>

          <div class="text-end mt-3">
            <button
              class="cancel_btn py-1 px-4 mx-3"
              type="button"
              @click.prevent="closeValidationRule()"
            >
              {{ $t("navigations.cancel") }}
            </button>
            <button
              type="button"
              class="save_btn py-1 px-3 position-relative"
              @click="saveValidationRule"
            >
              <div
                class="toc-loader position-absolute"
                :class="{
                  'opacity-0': !loadingValidationRule,
                  'opacity-1': loadingValidationRule,
                }"
              >
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  class="loading-btn-img"
                  alt="Waiting for login"
                />
              </div>
              <p
                class="mb-0"
                :class="{
                  'opacity-1': !loadingValidationRule,
                  'opacity-0': loadingValidationRule,
                }"
              >
                {{
                  isEditing ? $t("navigations.update") : $t("navigations.save")
                }}
              </p>
            </button>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./labValidationRule.js"></script>

<style scoped>
.data-grid {
  margin-top: 20px;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.position-relative img {
  width: 20px;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.3rem 0.8rem;
  right: 0;
  top: -20px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.scrollable {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
  background-color: #ffffff;
}
.errormsg {
  color: red;
  font-size: 12px;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
</style>
